export default "__VITE_ASSET__BjO59WrM__"